import "./CalendarAside.css";
import CalendarItem from "./CalendarItem/CalendarItem";
import { useContext, useEffect, useState } from "react";
import { Skeleton } from "@mantine/core";
import { groupByMonth } from "../../utils/group-by-month";
import axios from "axios";
import AuthContext from "../../contexts/AuthContext";
import showNotification from "../../utils/showNotification";
import { ERROR_HANDLER } from "../../utils/error-handler";

export default function CalendarAside() {
   const { authToken } = useContext(AuthContext)
   const [state, setState] = useState({ isLoading: false, error: null })
   const [schedule, setSchedule] = useState(null)

   useEffect(() => {
      const getSchedule = async () => {
         setState(prevState => ({...prevState, isLoading: true}))
         try {
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}campus/schedule`, {
               headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${authToken}`
               }
            })
            setSchedule(data)
         } catch (error) {
            showNotification({
               color: "red",
               status: "error",
               title: "Ha ocurrido un problema al cargar el calendario.",
               message: `Detalle: ${ERROR_HANDLER[error.request.status] || ERROR_HANDLER.defaultError}`
           })
         } finally{
            setState(prevState => ({...prevState, isLoading: false}))
         }
      }
      getSchedule()
   }, [authToken])

   const groupedByMonth = groupByMonth(schedule);

   if (state.error) return null;
   return (
      <>
         {state.isLoading && <Skeleton height="100%" radius="md" />}
         {!state.isLoading && !state.error && schedule && (
            <aside className="CalendarAside-container">
               <header className="CalendarAside-header-container">
                  <h3 className="CalendarAside-header--text">Calendario</h3>
               </header>

               {groupedByMonth && groupedByMonth.length > 0 ? (
                  <div className="CalendarAside-content">
                     {groupedByMonth.map((item) => (
                        <CalendarItem
                           key={item._id}
                           month={item.month}
                           events={item.events}
                        />
                     ))}
                  </div>
               ) : (
                  <p className="CalendarAside-empty">No hay eventos programados por el momento.</p>
               )}
            </aside>
         )}
      </>
   );
}
